module.exports = __webpack_public_path__ + "static/img/role-es.289c4a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/role-es.png
// module id = /B7z
// module chunks = 1